export default __webpack_public_path__ + "static/media/edit.adf45dcd.svg";